// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"c87804efd63a841b0c47","113":"26f36e923e86d05979e9","114":"48dfd2da75549ef509e1","162":"a27038d9a44b05c89cc6"}[chunkId] + ".chunk.js";
};